import { CustomException, request } from '@tencent/ppd-base-libs';
import { ActivityTypes } from '@tencent/wphk-act-base-types';
import { to, time } from '@tencent/wphk-base-utils';
import { getServerTime } from '@tencent/wphk-components-common/utils/server-time';
import { Ref, ref } from 'vue';
import isEmpty from 'lodash-es/isEmpty';


type ActCycleConfig = ActivityTypes.ActCycleConfig;

const MERCHANT_ID_CONF = 'foodpanda-share';

/** 灰度配置链接前缀，例如业务是 hengsheng-stamp, 则完整链接是 //st.moneydata.hk/res/cc/actcycle/hengsheng-stamp.json  */
const CONFIG_URL_PREFIX = 'https://st.moneydata.hk/res/cc/actcycle';
/** 获取配置的请求方法 */
const requestConfig = (business: string): Promise<ActCycleConfig[]> => request.loadConfig(`${CONFIG_URL_PREFIX}/${business}.json`);
/** 拉取业务配置 */
async function getConf(params: { business: string }): Promise<ActCycleConfig | undefined> {
  const { business } = params;
  const config = await requestConfig(business);
  return (config || []).find((conf: ActCycleConfig) => conf.business === business);
}

const isInAct = ref(false);
const actConf: Ref<ActCycleConfig | undefined> = ref();
export const useActCycle = () => {
  const initActCycleConf = async () => {
    if (!isEmpty(actConf.value)) {
      return;
    }
    const [err, conf] = await to(getConf({ business: MERCHANT_ID_CONF }));
    if (err || !conf) {
      throw new CustomException('', 'foodpandaActCycleFail', 'foodpanda获取活动时间配置失败');
    }
    isInAct.value = time.checkDateBetween({
      startTime: new Date(conf.businessStartTime),
      endTime: new Date(conf.businessEndTime),
      now: getServerTime(),
    });
    actConf.value = conf;
  };
  return {
    initActCycleConf,
    actConf,
    isInAct,
  };
};
